import http from '@/plugins/axios_plugin';

class ServiceLojas {

    // cidades (estado) {
    //     return http.get('/api/cidades?estado=' + estado);
    // }

    index (cliente_id) {
        return http.get('/api/clientes/' + cliente_id + '/lojas/listar')
    }

    salvar(cliente_id, loja) {
        return http.post('/api/clientes/' + cliente_id + '/lojas/salvar', loja);
    }

    editar(cliente_id, loja_id) {
        return http.get('/api/clientes/' + cliente_id + '/lojas/' + loja_id+ '/editar');
    }
    
    atualizar (cliente_id, loja) {
        return http.post('/api/clientes/' + cliente_id + '/lojas/' + loja.id+ '/atualizar', loja);
    }

    excluir(cliente_id, loja_id) {
        return http.post('/api/clientes/' + cliente_id + '/lojas/' + loja_id+ '/excluir');
    }

}

export default new ServiceLojas();